import script from "./VolunteerServeInvitation.vue?vue&type=script&setup=true&lang=js"
export * from "./VolunteerServeInvitation.vue?vue&type=script&setup=true&lang=js"

import "./VolunteerServeInvitation.vue?vue&type=style&index=0&id=470f1c7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-470f1c7a"]])

export default __exports__